import Login from './Login.json';

const ro = {
  Login,
};

export default ro;
